import store from '@/store'
import cookie from 'js-cookie'

export default (to, from, next) => {
  const token = to.params.token
  const accountId = to.params.account_id

  store.commit('AUTH_SET_TOKEN', token)
  cookie.set('selected_account_id', accountId, { expires: 60 }) // save

  next('/')
}



// WEBPACK FOOTER //
// ./src/middlewares/AccessMember.js